import React from "react";
import { useSelector } from "react-redux";

const useWebWorkerData = () => {
  const upcomingShifts = useSelector(
    (state: any) => state.worker.upcomingShifts
  );
  const location = useSelector((state: any) => state.worker.location);
  const shiftsConfirmed = useSelector(
    (state: any) => state.worker.shiftsConfirmed
  );

  const confirmShiftStatus = useSelector(
    (state: any) => state.worker.confirmShift.status
  );
  const lastConfirmedShiftDetails = useSelector(
    (state: any) => state.worker.confirmShift.lastConfirmedShiftDetails
  );

  const timeOffEnabled = useSelector(
    (state: any) => state.worker.settings.timeOffEnabled
  );

  const leaveTypes = useSelector(
    (state: any) => state.worker.getLeaveTypes.leaveTypes
  );
  const getleaveTypesStatus = useSelector(
    (state: any) => state.worker.getLeaveTypes.status
  );

  const shiftId = useSelector(
    (state: any) => state.worker.viewShiftDialog.shiftId
  );

  const allShiftsConfirmed = useSelector(
    (state: any) => state.worker.shiftsConfirmed
  );
  const reduxCancelShift = useSelector(
    (state: any) => state.worker.cancelShift
  );
  const skillLevels = useSelector((state: any) => state.worker.skillLevels);

  const confirmedShiftsErrorMessage = useSelector(
    (state: any) => state.worker.getConfirmedShifts.errorMessage
  );
  const getUpcomingShiftsErrorMessage = useSelector(
    (state: any) => state.worker.getUpcomingShifts.errorMessage
  );

  const signupShiftId = useSelector(
    (state: any) => state.worker.signupShiftDialog.shiftId
  );

  const allUpcomingShifts = useSelector(
    (state: any) => state.worker.upcomingShifts
  );

  const confirmShiftErrorMessage = useSelector(
    (state: any) => state.worker.confirmShift.errorMessage
  );

  const confirmShiftAcceptanceWindowClosed = useSelector(
    (state: any) => state.worker.confirmShift.acceptanceWindowClosed
  );

  const declineShiftStatus = useSelector(
    (state: any) => state.worker.declineShift.status
  );

  const declineShiftErrorMessage = useSelector(
    (state: any) => state.worker.declineShift.errorMessage
  );

  const confirmedShifts = useSelector(
    (state: any) => state.worker.shiftsConfirmed
  );

  const cancelShiftStatus = useSelector(
    (state: any) => state.worker.cancelShift.status
  );

  const cancelShiftType = useSelector(
    (state: any) => state.worker.cancelShift.type
  );

  const cancelShiftStartDateTime = useSelector(
    (state: any) => state.worker.cancelShift?.startDateTime
  );

  const cancelShiftEndDateTime = useSelector(
    (state: any) => state.worker.cancelShift?.endDateTime
  );
  const confirmedShiftsStatus = useSelector(
    (state: any) => state.worker.getConfirmedShifts.status
  );

  const isViewShiftsDialogOpen = useSelector(
    (state: any) => state.worker.viewShiftDialog.isOpen
  );

  const isViewRegularShiftPageOpen = useSelector(
    (state: any) => state.worker.viewRegularShiftPage.isOpen
  );

  const upcomingShiftsStatus = useSelector(
    (state: any) => state.worker.getUpcomingShifts.status
  );
  const isSignupShiftDialogOpen = useSelector(
    (state: any) => state.worker.signupShiftDialog.isOpen
  );

  const isCancelShiftPageOpen = useSelector(
    (state: any) => state.worker.isCancelShiftPageOpen
  );

  const isPartialShiftSignUpPageOpen = useSelector(
    (state: any) => state.worker.partialShiftSignUp.isOpen
  );

  const isFlexiShiftSignUpPageOpen = useSelector(
    (state: any) => state.worker.flexiShiftSignUp.isOpen
  );

  const leaveRequestPageOpen = useSelector(
    (state: any) => state.worker.leaveRequestPage.isOpen
  );
  const applyTimeOffPageOpen = useSelector(
    (state: any) => state.worker.applyTimeOffPage?.isOpen
  );

  const leaveRequestPageType = useSelector(
    (state: any) => state.worker.leaveRequestPage.type
  );

  const leaveRequestPageShift = useSelector(
    (state: any) => state.worker.leaveRequestPage.shift
  );

  const leaveRequestsStatus = useSelector(
    (state: any) => state.worker.getLeaveRequests.status
  );
  const leaveRequests = useSelector(
    (state: any) => state.worker.getLeaveRequests.leaveRequests
  );

  const fullTimeShiftSwapCancelEnabled = useSelector(
    (state: any) => state.worker.settings.fullTimeShiftSwapCancelEnabled
  );

  const withdrawLeaveRequestStatus = useSelector(
    (state: any) => state.worker.withdrawLeaveRequest.status
  );

  const partialSignupShiftId = useSelector(
    (state: any) => state.worker.partialShiftSignUp.shiftId
  );

  const flexiSignupShiftId = useSelector(
    (state: any) => state.worker.flexiShiftSignUp.shiftId
  );

  const isAcknowledgementPageOpen = useSelector(
    (state: any) => state.worker.isAcknowledgementPageOpen
  );

  const isEvaluationPageOpen = useSelector(
    (state: any) => state.workerEvaluations.isPageOpen
  );

  const getPasscodeStatus = useSelector(
    (state: any) => state.worker.getPasscode.status
  );

  const getPasscodeError = useSelector(
    (state: any) => state.worker.getPasscode.errorMessage
  );

  const getPasscodeErrorCode = useSelector(
    (state: any) => state.worker.getPasscode.errorCode
  );

  const verifyPasscodeStatus = useSelector(
    (state: any) => state.worker.verifyPasscode.status
  );

  const verifyPasscodeError = useSelector(
    (state: any) => state.worker.verifyPasscode.errorMessage
  );

  const verifyPasscodeIsLocked = useSelector(
    (state: any) => state.worker.verifyPasscode.isLocked
  );

  const authenticated = useSelector((state: any) => state.worker.authenticated);

  const refreshStatus = useSelector(
    (state: any) => state.worker.Refresh.status
  );

  const getSkillLevelsStatus = useSelector(
    (state: any) => state.worker.getSkillLevels.status
  );

  const getCustomLogoStatus = useSelector(
    (state: any) => state.worker.getCustomLogo.status
  );

  const customLogo = useSelector((state: any) => state.worker.customLogo);

  const getSettingsStatus = useSelector(
    (state: any) => state.worker.getSettings.status
  );

  const settings = useSelector((state: any) => state.worker.settings);

  const settingsInitialized = useSelector(
    (state: any) => state.worker.settings.initialized
  );

  const customizedBrandingEnabled = useSelector(
    (state: any) => state.worker.settings.customizedBrandingEnabled
  );

  const getCustomLogoResponse = useSelector(
    (state: any) => state.worker.getCustomLogo.response
  );

  const showSkill = useSelector(
    (state: any) => state.worker.settings.showSkill
  );

  const regularShifts = useSelector((state: any) => state.worker.regularShifts);

  const getRegularShiftsStatus = useSelector(
    (state: any) => state.worker.getRegularShifts.status
  );

  const workerType = useSelector((state: any) => state.worker.workerType);

  const regularShift = useSelector(
    (state: any) => state.worker.viewRegularShiftPage.shift
  );

  const canLoadMoreUpcomingShifts = useSelector(
    (state: any) => state.worker.getUpcomingShifts.canLoadMore
  );

  const canLoadMoreConfirmedShifts = useSelector(
    (state: any) => state.worker.getConfirmedShifts.canLoadMore
  );

  const canLoadMoreRegularShifts = useSelector(
    (state: any) => state.worker.getRegularShifts.canLoadMore
  );

  const viewShiftCanSwap = useSelector(
    (state: any) => !state.worker.viewShiftDialog.swap
  );

  const viewShiftStatus = useSelector(
    (state: any) => state.worker.viewShiftDialog.status
  );

  const weeklyHoursLimitMessage = useSelector(
    (state: any) => state.worker.confirmShift.weeklyHoursLimitMessage
  );

  const continuousWorkDayLimitMessage = useSelector(
    (state: any) => state.worker.confirmShift.continuousWorkDayLimitMessage
  );

  const confirmShiftConsecutiveShifts = useSelector(
    (state: any) => state.worker.confirmShift.shifts
  );

  const partialShiftCanSwap = useSelector(
    (state: any) => state.worker.partialShiftSignUp.swap
  );

  const flexiShiftCanSwap = useSelector(
    (state: any) => state.worker.flexiShiftSignUp.swap
  );

  const signupShiftCanSwap = useSelector(
    (state: any) => state.worker.signupShiftDialog.swap
  );

  const partialShiftSwapId = useSelector(
    (state: any) => state.worker.partialShiftSignUp.swapId
  );

  const flexiShiftSwapId = useSelector(
    (state: any) => state.worker.flexiShiftSignUp.swapId
  );

  const signupShiftSwapId = useSelector(
    (state: any) => state.worker.signupShiftDialog.swapId
  );

  const acknowledgements = useSelector(
    (state: any) => state.worker.acknowledgements
  );

  const acknowledgementsStatus = useSelector(
    (state: any) => state.worker.acknowledgements.status
  );

  const message = useSelector(
    (state: any) => state.worker?.cancelShift?.response?.message
  );
  const details = useSelector(
    (state: any) => state.worker?.cancelShift?.response?.details
  );

  const reduxForceCancelShift = useSelector(
    (state: any) => state.worker.forceCancelShift
  );

  const getCancelShiftReasonsStatus = useSelector(
    (state: any) => state.worker?.getCancelShiftReasons?.status
  );

  const attendanceAcknowledgementStatus = useSelector(
    (state: any) => state.worker.acknowledgeShift.status
  );
  const utilityWorker = useSelector(
    (state: any) => state.worker?.settings?.utilityWorker
  );

  const fullTimeSchedulingEnabled = useSelector(
    (state: any) => state.worker?.settings?.fullTimeSchedulingEnabled
  );

  const workerSetPrefEnabled = useSelector(
    (state: any) => state.worker?.settings?.workerSetPrefEnabled
  );

  const isWorkerPreferencePageOpen = useSelector(
    (state: any) => state.worker.isWorkerPreferencePageOpen
  );

  const getRequestTypesStatus = useSelector(
    (state: any) => state.worker.getRequestTypes.status
  );

  const requestTypes = useSelector(
    (state: any) => state?.worker?.getRequestTypes?.requestTypes
  );

  const submitLeaveRequestStatus = useSelector(
    (state: any) => state?.worker?.submitLeaveRequest?.status
  );
  const submitLeaveRequestErrorMessage = useSelector(
    (state: any) => state?.worker?.submitLeaveRequest?.errorMessage
  );

  const availableLeaveTypes = useSelector(
    (state: any) => state?.worker?.leaveRequestPage?.availableLeaveTypes
  );

  const workerProfile = useSelector(
    (state: any) => state.worker.workerProfile.data
  );

  const workerData = useSelector((state: any) => state.worker.workerData);
  const companyId = useSelector(
    (state: any) => state?.worker?.settings?.companyId
  );

  const getftSchedulingStatus = useSelector(
    (state: any) => state?.worker?.ftSchedulingStatus?.status
  );

  const ftSchedulingStatuses = useSelector(
    (state: any) => state?.worker?.ftSchedulingStatus?.schedulingStatus
  );

  const declinedShiftStartDateTime = useSelector(
    (state: any) => state.worker.declineShift.startDateTime
  );
  const declinedShiftEndDateTime = useSelector(
    (state: any) => state.worker.declineShift.endDateTime
  );
  const pairingEnabled = useSelector(
    (state: any) => state.worker.settings?.pairingEnabled
  );

  const submitLeaveRequestFtShiftId = useSelector(
    (state: any) => state.worker.submitLeaveRequest?.ftShiftId
  );

  const withdrawLeaveRequestFtShiftId = useSelector(
    (state: any) => state.worker.withdrawLeaveRequest?.ftShiftId
  );

  const vakaySSOLinkEnabled = useSelector(
    (state: any) => state.worker?.settings?.vakaySSOLinkEnabled
  );

  const workerEvaluationEnabled = useSelector(
    (state: any) => state.worker?.settings?.workerEvaluationEnabled
  );

  const assertVakaySSO = useSelector(
    (state: any) => state.worker?.assertVakaySSO
  );

  const submitLeaveRequest = useSelector(
    (state: any) => state.worker.submitLeaveRequest
  );

  const upcomingShiftsLoadedTill = useSelector(
    (state: any) => state.worker.getUpcomingShifts.loadedTill
  );

  const confirmedShiftsLoadedTill = useSelector(
    (state: any) => state.worker.getConfirmedShifts.loadedTill
  );

  const regularShiftsLoadedTill = useSelector(
    (state: any) => state.worker.getRegularShifts.loadedTill
  );

  return {
    refreshStatus,
    authenticated,
    verifyPasscodeError,
    verifyPasscodeStatus,
    verifyPasscodeIsLocked,
    getPasscodeError,
    getPasscodeStatus,
    getPasscodeErrorCode,
    upcomingShiftsStatus,
    isSignupShiftDialogOpen,
    confirmedShiftsStatus,
    isCancelShiftPageOpen,
    isAcknowledgementPageOpen,
    isEvaluationPageOpen,
    isViewShiftsDialogOpen,
    isViewRegularShiftPageOpen,
    confirmedShiftsErrorMessage,
    getUpcomingShiftsErrorMessage,
    upcomingShifts,
    shiftsConfirmed,
    location,
    confirmShiftStatus,
    lastConfirmedShiftDetails,
    allShiftsConfirmed,
    skillLevels,
    shiftId,
    reduxCancelShift,
    reduxForceCancelShift,
    signupShiftId,
    confirmShiftErrorMessage,
    confirmShiftAcceptanceWindowClosed,
    declineShiftStatus,
    declineShiftErrorMessage,
    allUpcomingShifts,
    cancelShiftStatus,
    confirmedShifts,
    getCancelShiftReasonsStatus,
    getSkillLevelsStatus,
    customLogo,
    getCustomLogoStatus,
    getCustomLogoResponse,
    getSettingsStatus,
    regularShifts,
    settings,
    settingsInitialized,
    customizedBrandingEnabled,
    showSkill,
    getRegularShiftsStatus,
    workerType,
    regularShift,
    canLoadMoreUpcomingShifts,
    canLoadMoreConfirmedShifts,
    canLoadMoreRegularShifts,
    viewShiftCanSwap,
    viewShiftStatus,
    weeklyHoursLimitMessage,
    confirmShiftConsecutiveShifts,
    signupShiftCanSwap,
    signupShiftSwapId,
    acknowledgements,
    acknowledgementsStatus,
    message,
    details,
    attendanceAcknowledgementStatus,
    cancelShiftType,
    cancelShiftStartDateTime,
    cancelShiftEndDateTime,
    isPartialShiftSignUpPageOpen,
    isFlexiShiftSignUpPageOpen,
    partialSignupShiftId,
    flexiSignupShiftId,
    partialShiftCanSwap,
    flexiShiftCanSwap,
    partialShiftSwapId,
    flexiShiftSwapId,
    timeOffEnabled,
    leaveTypes,
    leaveRequestPageOpen,
    applyTimeOffPageOpen,
    leaveRequestPageType,
    leaveRequestPageShift,
    leaveRequestsStatus,
    leaveRequests,
    fullTimeShiftSwapCancelEnabled,
    withdrawLeaveRequestStatus,
    getRequestTypesStatus,
    requestTypes,
    submitLeaveRequestStatus,
    submitLeaveRequestErrorMessage,
    submitLeaveRequestFtShiftId,
    availableLeaveTypes,
    companyId,
    utilityWorker,
    fullTimeSchedulingEnabled,
    workerSetPrefEnabled,
    isWorkerPreferencePageOpen,
    getleaveTypesStatus,
    getftSchedulingStatus,
    ftSchedulingStatuses,
    declinedShiftStartDateTime,
    declinedShiftEndDateTime,
    continuousWorkDayLimitMessage,
    pairingEnabled,
    withdrawLeaveRequestFtShiftId,
    vakaySSOLinkEnabled,
    workerEvaluationEnabled,
    assertVakaySSO,
    submitLeaveRequest,
    upcomingShiftsLoadedTill,
    confirmedShiftsLoadedTill,
    regularShiftsLoadedTill,
    workerData,
    workerProfile,
  };
};

export default useWebWorkerData;
